<template>
  <div ref="wrapper" uk-toggle="target: #documentation-side-menu">
    <div v-if="isLoggedIn" class="tab" id="custom-sidebar-trigger">
            <draggable
                    class="dragArea list-group"
                    :list="displayList"
                    :group="{ name: 'fields', pull: 'clone', put: () => true }"
                    :sortable="false"
                    @add="handleAdded"
            ></draggable>
       <span uk-icon="icon: question" style="color: white"></span>
    </div>
  </div>

</template>

<script>
    import Draggable from "vuedraggable";
    import UIkit from 'uikit'; // necessary for intro stuff

	export default {
		name: "DocumentationPanelTab",
        components: {Draggable},
        data: function() {
		    return {
		        displayList: []
            }
        },
        computed: {
            isLoggedIn: function () {
                return this.$store.state.user.logged_in;
            },
        },
        methods: {
		    handleAdded: function() {
		        console.log(this.displayList);
		        this.$emit('questionObject', this.displayList[0].name)
                UIkit.offcanvas('#documentation-side-menu').show()
            }
        }
	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";


  .tab {
      cursor: pointer;
    position: fixed;
    height: 65px;
    width: 40px;
    top: 30%;
    left: -2px;//negative of border
    margin-top: -1em; //half of height

    background: @primary-1;
    border: @primary-2 1px solid;

    opacity: .9;

    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;

    display: flex;
    align-items: center;
    justify-content: center;


    &:hover {
      opacity: 1;
    }

    span {
      color: @secondary-2;
    }


  }


</style>
